export const analyticsCategory = 'GLOBAL_NAV_USER_MENU'
